import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import ScrollToTopButton from "../../components/ScrollToTopButton/ScrollToTopButton";
import DarkModeButton from "../../components/DarkModeButton/DarkModeButton";
import "./Support.css";

export default function Support() {
  const [modalType, setModalType] = useState(null);
  const [bankType, setBankType] = useState('helyi');


  useEffect(() => {
    document.title = "Kútonline - Támogatás";
  }, []);

  const openModal = (type) => (e) => {
    e.preventDefault();
    setModalType(type);
    if (type === 'tamogatas') setBankType('helyi');
 
  };
  const closeModal = () => setModalType(null);

  return (
    <div>
      <Navbar />
      <DarkModeButton />
      <div className="page-container support-container" style={modalType ? {filter: 'blur(2px)', pointerEvents: 'none'} : {}}>
        <h2>Miért támogass minket?</h2>
        <p className="support-p"> 
          A <strong>Kút Online</strong> fiatalok kezdeményezése. Támogatásoddal lehetőséget adsz nekünk a fejlődésre, új témák és formátumok kipróbálására.
        </p>
        <h3 className="support-h3">Támogatási lehetőségek</h3>
        <div className="support-options">
            <div className="support-card support-card-transfer">
                <img className="support-card-transfer-image-light" src="/images/adomany.jpg" alt="Adományozás" onClick={openModal('tamogatas')} style={{cursor: 'pointer'}}/>
                <img className="support-card-transfer-image-dark" src="/images/adomany_darkmode.jpg" alt="Adományozás" onClick={openModal('tamogatas')} style={{cursor: 'pointer'}}/>
                <h4>Átutalás</h4>
                <p>Támogatásodat banki átutalással, a megadott számlaszámra tudod eljuttatni.</p>
                <button className="support-btn" onClick={openModal('tamogatas')}>Támogatás</button>
            </div>
            <div className="support-card support-card-repont">
                <img src="/images/repont.jpg" alt="Repont" onClick={openModal('megosztas')} style={{cursor: 'pointer'}}/>
                <h4>Repont</h4>
                <p>Hogyha a képen látható QR kódot beolvassátok az üvegvisszaváltó automatákban, mielőtt elkezditek bedobni a palackokat, akkor az üvegekért járó Forintokkal minket támogattok.</p>
                <button className="support-btn" onClick={openModal('megosztas')}>Repont</button>
            </div>
            <div className="support-card support-card-tax">
                <img src="/images/tax.jpg" alt="Adó 1%" onClick={openModal('info')} style={{cursor: 'pointer'}}/>
                <h4> 1% is számít</h4>
                <p>Ajánld fel adód 1%-át!<br/> Adószámunk: <strong>19419365-1-18</strong></p>
                <button className="support-btn-1" onClick={openModal('info')}>További információ</button>
            </div>
        </div>
      </div>
      {/* MODÁLIS ABLAKOK */}
      {modalType === 'tamogatas' && (
        <div className="support-modal-overlay" onClick={closeModal}>
          <div className="support-modal" onClick={e => e.stopPropagation()} style={{position: 'relative'}}>
            {/* Bezárás X ikon jobb felső sarokban */}
            <button onClick={closeModal} style={{position: 'absolute', top: '10px', right: '10px', background: 'transparent', border: 'none', fontSize: '22px', color: '#0e9179', fontWeight: 'bold', cursor: 'pointer', zIndex: 2}} aria-label="Bezárás">×</button>
            <div className="support-modal-body">
              <h3 className="support-modal-title">Bankszámlaadatok</h3>
              <div className="support-modal-banktype-group">
                <button className={`support-modal-banktype-btn${bankType === 'helyi' ? ' active' : ''}`} onClick={() => setBankType('helyi')}>Helyi</button>
                <button className={`support-modal-banktype-btn${bankType === 'swift' ? ' active' : ''}`} onClick={() => setBankType('swift')}>SWIFT</button>
              </div>
              {bankType === 'helyi' ? (
                <div className="support-modal-bankdata">
                  <p><strong>SZÁMLATULAJDONOS:</strong><br/>Dunántúli Népművészeti Egyesület <br/>(9700 Szombathely, Kisfaludy Sándor utca 25.)</p>
                  <p><strong>SZÁMLASZÁM:</strong><br/>16200687-10007273</p>
                  <p><strong>BANK:</strong><br/>MagNet Bank ZRT.</p>
                </div>
              ) : (
                <div className="support-modal-bankdata">
                  <p><strong>SZÁMLATULAJDONOS:</strong><br/>Dunántúli Népművészeti Egyesület <br/>(9700 Szombathely, Kisfaludy Sándor utca 25.)</p>
                  <p><strong>IBAN:</strong><br/>HU27 16200687 10007273 0000 0000</p>
                  <p><strong>SWIFT KÓD:</strong><br/>HBWEHUHBXXX</p>
                  <p><strong>BANK:</strong><br/>MagNet Magyar Közösségi Bank Zrt.</p>
                  <p><strong>A MAGNET BANK SZÉKHELYE:</strong><br/>1062 Budapest, Andrássy út 98.</p>
                </div>
              )}
              <button className="support-modal-close" onClick={closeModal}>Bezárás</button>
            </div>
          </div>
        </div>
      )}
      {modalType === 'megosztas' && (
        <div className="support-modal-overlay" onClick={closeModal}>
          <div className="support-modal" onClick={e => e.stopPropagation()} style={{position: 'relative'}}>
            {/* Bezárás X ikon jobb felső sarokban */}
            <button onClick={closeModal} className="support-modal-close-x" aria-label="Bezárás">×</button>
            <div className="support-modal-body">
              <h3 className="support-modal-title">Repont</h3>
              <div style={{position: 'relative', display: 'inline-block'}}>
                <img id="repont-img" src="/images/repont.jpg" alt="Repont QR kód" className="support-modal-shareimg" style={{maxWidth: '100%', borderRadius: '8px'}} />
                {/* Letöltés ikon jobb alsó sarokban */}
                <a href="/images/repont.jpg" download className="support-modal-download-icon" style={{position: 'absolute', right: '10px', bottom: '10px', background: '#fff', borderRadius: '50%', padding: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.12)', cursor: 'pointer'}} title="Letöltés">
                  <svg width="24" height="24" fill="none" stroke="#0e9179" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>
                </a>
                {/* Teljes képernyő ikon jobb felső sarokban */}
                <button className="support-modal-fullscreen-icon" style={{position: 'absolute', right: '10px', top: '10px', background: '#fff', borderRadius: '50%', padding: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.12)', border: 'none', cursor: 'pointer'}} title="Teljes képernyő" onClick={() => {
                  const img = document.getElementById('repont-img');
                  if (img.requestFullscreen) img.requestFullscreen();
                  else if (img.webkitRequestFullscreen) img.webkitRequestFullscreen();
                  else if (img.msRequestFullscreen) img.msRequestFullscreen();
                }}>
                  {/* 4 irányba mutató nyilak (fullscreen/expand) ikon SVG */}
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0e9179" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="4 8 4 4 8 4" />
                    <line x1="4" y1="4" x2="9" y2="9" />
                    <polyline points="20 8 20 4 16 4" />
                    <line x1="20" y1="4" x2="15" y2="9" />
                    <polyline points="4 16 4 20 8 20" />
                    <line x1="4" y1="20" x2="9" y2="15" />
                    <polyline points="20 16 20 20 16 20" />
                    <line x1="20" y1="20" x2="15" y2="15" />
                  </svg>
                </button>
              </div>
              <p className="support-modal-note"></p>
              <button className="support-modal-close" onClick={closeModal}>Bezárás</button>
            </div>
          </div>
        </div>
      )}
      {modalType === 'info' && (
        <div className="support-modal-overlay" onClick={closeModal}>
          <div className="support-modal" onClick={e => e.stopPropagation()} style={{position: 'relative'}}>
            {/* Bezárás X ikon jobb felső sarokban */}
            <button onClick={closeModal} style={{position: 'absolute', top: '10px', right: '10px', background: 'transparent', border: 'none', fontSize: '22px', color: '#0e9179', fontWeight: 'bold', cursor: 'pointer', zIndex: 2}} aria-label="Bezárás">×</button>
            <div className="support-modal-body">
              <h3 className="support-modal-title">Adó 1%</h3>
              <div className="support-modal-bankdata">
                <p><strong>Kedvezményezett neve:</strong><br/>Dunántúli Népművészeti Egyesület</p>
                <p><strong>Cím:</strong><br/>9700 Szombathely, Kisfaludy Sándor utca 25.</p>
                <p><strong>Adószám:</strong><br/>19419365-1-18</p>
              </div>
              <button className="support-modal-close" onClick={closeModal}>Bezárás</button>
            </div>
          </div>
        </div>
      )}
      <ScrollToTopButton />
    </div>
  );
}